// extracted by mini-css-extract-plugin
export default {"metrics_tab":"MetricsTab_metrics_tab__AVYNz"};